import classNames from 'classnames';
import { useInView } from 'react-intersection-observer';
import {
  CloudinaryImageWrapper,
  type CloudinaryImageWrapperProps,
} from '../../../../components/CloudinaryImageWrapper';
import styles from './style.module.scss';

export interface DynamicAdsImageProps {
  onView?: () => void;
  image: Pick<CloudinaryImageWrapperProps, 'src' | 'alt'>;
  aspectRatio: CloudinaryImageWrapperProps['sources'];
}

export const DynamicAdsImage = ({
  onView,
  image,
  aspectRatio,
}: DynamicAdsImageProps) => {
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true,
    onChange: isInView => isInView && onView?.(),
  });

  return (
    <div className={styles.imageContainer}>
      <div
        data-testid="gallery-image"
        className={classNames(styles.image, {
          [styles.inView]: inView,
        })}
        ref={ref}
      >
        <CloudinaryImageWrapper
          alt={image.alt}
          src={image.src}
          sources={aspectRatio}
          lazy
          convertToCloudFront={false}
          transforms={{
            ar: '1',
            e: ['replace_color:f2f3f4:300:ffffff'],
          }}
        />
      </div>
    </div>
  );
};
